export const WELCOME_TRANSLATE = {
    welcome: {
        breadcrumbName: "Bienvenido",
        actions: {
            continue: {
                text: "Continuar"
            }
        },
        save: {
            form: {
                fields: {
                    acceptUseTerms: {
                        label: "He leído y acepto los términos anteriores"
                    }
                }
            }
        }
    }
}
